/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_prob_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No outcome is ever shown as 0% or 100% — crashes, DNFs, and safety cars can always change the result.`)
};

const es_f1_budget_prob_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún resultado se muestra como 0% o 100% — accidentes, DNFs y safety cars siempre pueden cambiar el resultado.`)
};

const de_f1_budget_prob_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Ergebnis wird als 0% oder 100% angezeigt — Unfälle, DNFs und Safety Cars können das Ergebnis immer ändern.`)
};

const nl_f1_budget_prob_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen resultaat wordt weergegeven als 0% of 100% — crashes, DNFs en safety cars kunnen het resultaat altijd veranderen.`)
};

const fr_f1_budget_prob_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun résultat n’est affiché à 0% ou 100% — accidents, DNFs et safety cars peuvent toujours changer le résultat.`)
};

const it_f1_budget_prob_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun risultato viene mostrato come 0% o 100% — incidenti, DNF e safety car possono sempre cambiare il risultato.`)
};

const pt_br2_f1_budget_prob_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado é mostrado como 0% ou 100% — batidas, DNFs e safety cars sempre podem mudar o resultado.`)
};

const pt_f1_budget_prob_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado é mostrado como 0% ou 100% — acidentes, DNFs e safety cars podem sempre alterar o resultado.`)
};

const ja_f1_budget_prob_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの結果も0%゚100%とは表示されません — クラッシュ、DNF、セーフティカーが常に結果を変える可能性があるためです。`)
};

const zh_f1_budget_prob_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有任何结果会显示为0%或0%——碰撞、退赛和安全车始终可能改变结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_prob_p4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_prob_p4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_prob_p4", locale)
	if (locale === "en") return en_f1_budget_prob_p4(inputs)
	if (locale === "es") return es_f1_budget_prob_p4(inputs)
	if (locale === "de") return de_f1_budget_prob_p4(inputs)
	if (locale === "nl") return nl_f1_budget_prob_p4(inputs)
	if (locale === "fr") return fr_f1_budget_prob_p4(inputs)
	if (locale === "it") return it_f1_budget_prob_p4(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_prob_p4(inputs)
	if (locale === "pt") return pt_f1_budget_prob_p4(inputs)
	if (locale === "ja") return ja_f1_budget_prob_p4(inputs)
	return zh_f1_budget_prob_p4(inputs)
};